import React, { useEffect, useState } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../partials/content/Forms/AppForm";
import {
  getProductionOrderStocks,
  unloadProductionStock,
} from "../../../../services/production/productionService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { DialogActions, InputAdornment } from "@material-ui/core";
import { FieldArray, useFormikContext } from "formik";
import { Badge, Card } from "react-bootstrap";
import {
  FormOutlinedTextField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { CustomOutlinedDisabledTextField } from "../../../../partials/content/Forms";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
const stockUnloadSchema = yup.object().shape({
  qty: yup
    .number()
    .required("Qty Return is required")
    .min(1, "Qty Return is required")
    .default(0),
});
function ProductionOrderStocks({ productionOrderID = 0 }) {
  const [productionOrderStocks, setProductionOrderStocks] = useState([]);
  const [selectedStock, setSelectedStock] = useState({
    ID: 0,
    itemCode: "",
    itemID: 0,
    itemName: 0,
    batchID: 0,
    qty: 0,
    uomName: "",
  });
  const [openUnloadStockForm, setOpenUnloadStockForm] = useState(false);

  const getProductionOrderStocksData = async (productionOrderID = 0) => {
    const response = await getProductionOrderStocks(productionOrderID);
    const { data } = response.data;
    setProductionOrderStocks(data.productionOrderStocks);
  };
  useEffect(() => {
    getProductionOrderStocksData(productionOrderID);
  }, [productionOrderID]);
  return (
    <React.Fragment>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Item Code</th>
            <th>Item</th>
            <th>Batch ID</th>
            <th>Qty</th>
            <th>Unit</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {productionOrderStocks.map((stock, index) => (
            <tr key={index}>
              <td>{stock.itemCode}</td>
              <td>{stock.itemName}</td>
              <td>{stock.batchID}</td>
              <td>{stock.qty}</td>
              <td>{stock.uomName}</td>
              <td>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    setSelectedStock(stock);
                    setOpenUnloadStockForm(true);
                  }}
                >
                  Unload Stock
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <DialogLayout
        open={openUnloadStockForm}
        title="Unload Production Stock"
        onCloseDialog={() => {
          setOpenUnloadStockForm(false);
        }}
        maxWIdth="md"
      >
        <ProductionOrderStockUnloadForm
          stock={selectedStock}
          onConfirmSave={() => {
            getProductionOrderStocksData(productionOrderID);
            setOpenUnloadStockForm(false);
          }}
          onCloseDialog={() => {
            setOpenUnloadStockForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

function ProductionOrderStockUnloadForm({
  stock,
  onConfirmSave,
  onCloseDialog,
}) {
  const [productionOrderStockUnload, setProductionOrderStockUnload] = useState({
    warehouseID: stock.warehouseID,
    warehouseName: stock.warehouseName,
    productionOrderStockID: stock.ID,
    productionOrderID: stock.productionOrderID,
    itemID: stock.itemID,
    itemCode: stock.itemCode,
    itemName: stock.itemName,
    varCode: stock.varCode,
    batchID: stock.batchID,
    qtyOri: stock.qty,
    qty: 0,
    status: 1,
    uomID: stock.uomID,
    uomName: stock.uomName,
  });
  return (
    <AppForm
      initialValues={productionOrderStockUnload}
      validationSchema={stockUnloadSchema}
      headSubmitButton
      onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
        console.log(values, "data ok");
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this stock unload ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              const productionUnloadStock = { ...values };
              productionUnloadStock.qtyOri = parseFloat(
                productionOrderStockUnload.qtyOri
              );
              productionUnloadStock.qty = parseFloat(productionUnloadStock.qty);
              unloadProductionStock(productionUnloadStock).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <StockUnloadFormContent />
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        <button
          type="submit"
          className="btn btn-success btn-md btn-pill btn-bold"
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </AppForm>
  );
}

function StockUnloadFormContent() {
  const { values } = useFormikContext();
  return (
    <FieldArray name="data">
      {({ push, remove }) => (
        <React.Fragment>
          <div className="row mb-3">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-window-maximize"></i>
                  <span>
                    <strong>Stock Return Header</strong>
                  </span>
                  <Badge
                    className="float-right ml-1"
                    variant={
                      values.statusID === 1
                        ? "info"
                        : values.statusID === 3
                        ? "success"
                        : values.statusID === 4
                        ? "warning"
                        : values.statusID === 5
                        ? "primary"
                        : values.statusID === 9
                        ? "danger"
                        : values.statusID === 10
                        ? "danger"
                        : null
                    }
                  >
                    {values.statusID === 1
                      ? "Stock Requested"
                      : values.statusID === 3
                      ? "Stock Loaded"
                      : values.statusID === 4
                      ? "Stock Partially Returned"
                      : values.statusID === 5
                      ? "Stock Returned"
                      : values.statusID === 9
                      ? "Stock Cancelled"
                      : values.statusID === 10
                      ? "Stock Rejected"
                      : null}
                  </Badge>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormOutlinedTextField
                        label="Item Code"
                        value={values.itemCode}
                        InputProps={{
                          startAdornment:
                            values.itemType > 0 ? (
                              <InputAdornment position="start">
                                <BootstrapTooltip title={values.itemTypeName}>
                                  <i
                                    className={
                                      values.itemType === 1
                                        ? "fas fa-boxes text-success"
                                        : values.itemType === 2
                                        ? "fas fa-tools text-primary"
                                        : values.itemType === 3
                                        ? "fas fa-building text-info"
                                        : values.itemType === 4
                                        ? "fas fa-boxes text-warning"
                                        : values.itemType === 5
                                        ? "fas fa-boxes text-danger"
                                        : null
                                    }
                                  ></i>
                                </BootstrapTooltip>
                              </InputAdornment>
                            ) : null,
                          readOnly: true,
                        }}
                      />
                      <CustomOutlinedDisabledTextField
                        label="Item Name"
                        value={values.itemName}
                      />
                      <FormTextField
                        label="Return Qty"
                        name="qty"
                        quantityField
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Warehouse"
                        value={values.warehouseName}
                      />
                      <CustomOutlinedDisabledTextField
                        label="Batch ID"
                        value={values.batchID}
                      />
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Qty"
                            value={values.qtyOri}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <CustomOutlinedDisabledTextField
                            label="Unit"
                            value={values.uomName}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </React.Fragment>
      )}
    </FieldArray>
  );
}

export default ProductionOrderStocks;
